import { useRef } from 'react'
import { createPortal } from 'react-dom'

import { mtc } from '@/styles'
import { useAnchorRect } from './useAnchorRect'

interface GlowingAnchorDotProps {
  // False once the user has clicked into this item (or its nested page), or
  // the tour has moved past it — fades the dot out rather than removing it.
  visible: boolean
}

const dotStyles =
  'fixed z-50 h-3 w-3 rounded-full bg-green-50 shadow-[0_0_12px_3px_rgba(88,175,142,0.7)] pointer-events-none'

// One dot per anchored sidebar item, right of the label. Portalled to the
// document root because the glow spills well past the 12px dot and the sidebar
// footer's clip-path crops even fixed-position descendants. A zero-glow
// placeholder stays inline to hold the row footprint and give the dot an
// anchor to track.
export const GlowingAnchorDot = ({ visible }: GlowingAnchorDotProps) => {
  const anchorRef = useRef<HTMLSpanElement>(null)
  const position = useAnchorRect(anchorRef)

  return (
    <>
      <span
        ref={anchorRef}
        aria-hidden="true"
        className="inline-block h-3 w-3 shrink-0"
      />
      {position &&
        createPortal(
          <span
            aria-hidden="true"
            className={mtc(
              dotStyles,
              visible
                ? 'animate-announcement-glow'
                : 'opacity-0 transition-opacity duration-300'
            )}
            style={{ top: position.top, left: position.left }}
          />,
          document.body
        )}
    </>
  )
}
